import {
  SHOULD_UPDATE_FOLLOWING_STATUS,
  UPDATE_FOLLOWING_STATUS,
  UPDATE_IS_FETCHING_ATHLETES,
  UPDATE_IS_FETCHING_SUGGESTIONS,
  UPDATE_DISPLAY_SUGGESTIONS_MODAL,
  UPDATE_HAS_MORE_SUGGESTIONS,
  UPDATE_SHOW_TEAMMATES_STATUS,
  UPDATE_SHOW_ONBOARDING_BEACON,
  UPDATE_SHOULD_REFRESH_SUGGESTIONS,
  UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS,
} from 'shared/actionTypes';

export default function contentSuggestionsWidget(state = {}, action) {
  let isFetching;
  let showTeammates;

  switch (action.type) {
  case SHOULD_UPDATE_FOLLOWING_STATUS:
    return Object.assign({}, state, {
      shouldUpdateFollowingTeam: action.payload.newValue,
    });
  case UPDATE_FOLLOWING_STATUS:
    const {
      newValue,
    } = action.payload;
    return Object.assign({}, state,  {
      isFollowingTeam: newValue,
      shouldUpdateFollowingTeam: false,
    });
  case UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS:
    return Object.assign({}, state,  {
      isRefreshingWidgetSuggestions: action.payload.isFetching,
    });
  case UPDATE_IS_FETCHING_ATHLETES:
    isFetching = action.payload.isFetching;
    return Object.assign({}, state, {
      isFetchingAthletes: isFetching,
    });
  case UPDATE_IS_FETCHING_SUGGESTIONS:
    isFetching = action.payload.isFetching;
    return Object.assign({}, state, {
      isFetchingSuggestions: isFetching,
    });
  case UPDATE_SHOW_TEAMMATES_STATUS:
    showTeammates = action.payload.showTeammates;
    return Object.assign({}, state, {
      showTeammates,
    });
  case UPDATE_SHOW_ONBOARDING_BEACON:
    const { showOnboardingBeacon } = action.payload.showOnboardingBeacon;
    return Object.assign({}, state, {
      showOnboardingBeacon,
    });
  case UPDATE_SHOULD_REFRESH_SUGGESTIONS:
    const { refreshSuggestions } = action.payload;
    return Object.assign({}, state,  {
      refreshSuggestedAthletes: refreshSuggestions,
    });
  case UPDATE_DISPLAY_SUGGESTIONS_MODAL:
    const { shouldShowModal } = action.payload;
    return Object.assign({}, state,  {
      shouldShowSuggestionsModal: shouldShowModal,
    });
  case UPDATE_HAS_MORE_SUGGESTIONS:
    return Object.assign({}, state,  {
      hasMoreSuggestions: action.payload.newValue,
    });
  default:
    return state;
  }
}
